import React from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

const FeedbackInvitation = () => {
  const { t } = useTranslation()

  return (
    <div className="px-4 py-8 bg-blue-100 text-center">
      <h3 className="text-2xl mb-4">{t("feedback-invitation-title")}</h3>
      <p className="text-lg mb-4">{t("feedback-invitation-description")}</p>
      <Link
        to="/feedback"
        className="inline-block py-2 px-4 bg-blue-500 text-white rounded"
      >
        {t("provide-feedback")}
      </Link>
    </div>
  )
}

export default FeedbackInvitation
